import PropTypes from "prop-types"
import React from "react"
import { MenuItem, Nav, Navbar, NavDropdown } from "react-bootstrap"
import logo from "../images/logoV2.png"
import { Link } from 'gatsby'

const HeaderStyle = {
  'marginBottom': '0px'
}
const Header = () => {
  const strataPortalUrl = `${process.env.GATSBY_API_URL}/strataLogin`
  const residentialPortalUrl = `${process.env.GATSBY_API_URL}/login`

  return (
    <Navbar collapseOnSelect style={HeaderStyle}>
      <Navbar.Header>
        <Link to="/">
          <Navbar.Brand>
             <img src={logo} className="logo" alt="Korecki Real Estate Services" />
          </Navbar.Brand>
         </Link>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav pullRight>
          <MenuItem eventKey={1} href="/">
            Home
          </MenuItem>

          <NavDropdown eventKey={2} title="Strata" id="strata-nav-dropdown">
            <MenuItem eventKey={2.1} href='/strata'>
              Strata Management
            </MenuItem>
            <MenuItem eventKey={2.2} href='/strata/request'>
              Strata Proposal Request
            </MenuItem>
            <MenuItem eventKey={2.3} href='/strata/documents'>
              Strata Documents
            </MenuItem>
          </NavDropdown>

          <NavDropdown eventKey={3} title="Residential" id="residential-nav-dropdown">
            <MenuItem eventKey={3.1} href='/residential'>
              Residential Management
            </MenuItem>
            <MenuItem eventKey={3.2} href='/residential/request'>
              Residential Proposal Request
            </MenuItem>
          </NavDropdown>

          <MenuItem eventKey={4} href='/listings'>
            Listings
          </MenuItem>

          <NavDropdown eventKey={5} title="About" id="about-nav-dropdown">
            <MenuItem eventKey={5.1} href='/company'>
              Corporate Profile
            </MenuItem>
            <MenuItem eventKey={5.2} href='/careers'>
              Careers
            </MenuItem>
          </NavDropdown>

          <NavDropdown eventKey={6} title="FAQ" id="faq-nav-dropdown">
            <MenuItem eventKey={6.1} href='/faq/strata-faq'>
              Strata FAQ
            </MenuItem>
            <MenuItem eventKey={6.2} href='/faq/residential-faq'>
              Residential FAQ
            </MenuItem>
          </NavDropdown>

          <MenuItem eventKey={7} href='/contact'>
            Contact
          </MenuItem>

          <NavDropdown eventKey={8} title="Login" id="login-nav-dropdown">
            <MenuItem eventKey={8.1} href={strataPortalUrl}>
              Strata Login
            </MenuItem>
            <MenuItem eventKey={8.2} href={residentialPortalUrl}>
              Residential Login
            </MenuItem>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
